import { render, staticRenderFns } from "./PicklrItem.vue?vue&type=template&id=07459b06&scoped=true&"
import script from "./PicklrItem.vue?vue&type=script&lang=js&"
export * from "./PicklrItem.vue?vue&type=script&lang=js&"
import style0 from "./PicklrItem.vue?vue&type=style&index=0&id=07459b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07459b06",
  null
  
)

export default component.exports